import React, { Component } from 'react';
import { connect } from 'react-redux';
import { SEARCH_TYPES, ISort } from '../models';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
import { IStore } from 'reducers/index';
import { ISortModel, SORT_ORDER } from 'reducers/filters/models';
import { setSort, resetSort } from 'actions/filters';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { isEmptyError } from 'utilities/validate';
import { bulkDownloadExportJobs, fetchExportJobs, fetchExportJobsPageForDownload, resetExportJobs } from 'actions/exportJob';
import { displayFilters } from 'actions/filters';
import { fetchExportJobDropdown } from 'actions/exportJob';
import { FiltersInput } from 'modules/filters/components/FiltersInput';
import { FiltersDateInput } from 'modules/filters/components/FiltersDateInput';
import InPageDialog from '../../../../components/page-dialog';
import { Filters } from 'modules/filters/containers/Filters';
import { FiltersSelect } from 'modules/filters/components/FiltersSelect';
import { TabComponent } from 'components/sub-navigation/components/TabComponent';
import { groupBydocumentType, getAgingBucket } from '../../../../utilities/util';
import { ExportJObCols } from './models';
import { Search } from '../Search';
import { FEATURE_TOGGLES } from 'constants/featureToggles';
import { isFeatureEnabled, lastThreeMonthsFilters } from 'utilities/util';
import { IFeatureToggleModel } from 'reducers/featureToggle/models';
import { setFilter } from 'actions/filters';
import { IExportJobs } from 'reducers/exportJob/models';
import { originDestDropdown, messageDropdown, uamType, pricingSourceOptions } from '../../../../constants/customs';
import { ModalMain } from 'damco-components';
import { BulkDownload } from 'modules/bulk-download/bulk-download';
import { UploadSection } from 'modules/bulk-upload/upload-section';
import { searchProductTypes, searchCBLStatuses } from 'constants/statuses';
import CustomTable from 'components/custom-table';

interface IMapDispatchToProps {
    fetchExportJobs: (pageNumber: number, pageSize: number, genericFilter: string) => Promise<void>;
    setSort: (sort: ISortModel) => void;
    resetSort: () => void;
    displayFilters: (hideFilters: boolean, target: string) => void;
    resetExportJobs: () => void;
    setFilter: (name: string, value: string | boolean | any[] | number) => void;
    fetchExportJobDropdown: () => void;
    bulkDownloadExportJobs: (exportJobIds: any) => Promise<void>;
    fetchExportJobsPageForDownload: (pageNumber: number, pageSize: number) => Promise<any[]>;
}

interface IMapStateToProps {
    isFetchSearchDataLoading: boolean;
    isFetchSearchDataError: boolean;
    searchPendingError: string | string[],
    exportJobs: IExportJobs,
    filters: any,
    currentFilters: any,
    featureToggles: IFeatureToggleModel[],
    documentDropdownData: any,
    userPermissions: any,
}

interface IProps extends RouteComponentProps, IMapStateToProps, IMapDispatchToProps { }

interface IState {
    sorted: any[] | ISort[];
    genericFilter: string;
    withoutFilters: boolean;
    page: number | undefined;
    pageSize: number;
    totalCount: number;
    isFetchinProgress: boolean;
    clearFilters: boolean;
    pendingError: string | string[];
    etaFrom: boolean,
    etdFrom: boolean,
    jobCreationDateFrom: boolean,
    activeTab: number,
    typeOfSearch: string,
    exportJobs: any[],
    shouldClear: boolean;
    showDialog: boolean;
    hasData: boolean;
    errorMsg: string | null,
    primaryDocument: string[],
    primaryDocumentStatus: string[],
    selectedPrimaryDocument: string,
    selectedPrimaryDocumentStatus: string,
    dropdownData: string[],
    showDownloadModal: boolean;
    isPaginationClicked: boolean;
    showUploadModal: boolean;
    bulkUploadTitle: string;
    filtersApplied?: boolean;
}
export class _SearchExportJobs extends Component<IProps, IState> {
    public state = {
        sorted: [],
        genericFilter: '',
        withoutFilters: false,
        page: 1,
        pageSize: 10,
        totalCount: 0,
        isFetchinProgress: true,
        etaFrom: false,
        etdFrom: false,
        jobCreationDateFrom: false,
        pendingError: '',
        typeOfSearch: SEARCH_TYPES.EXPORTJOB,
        activeTab: 3,
        exportJobs: [],
        clearFilters: false,
        shouldClear: false,
        showDialog: false,
        hasData: false,
        errorMsg: '',
        primaryDocument: [],
        primaryDocumentStatus: [],
        selectedPrimaryDocument: '',
        selectedPrimaryDocumentStatus: '',
        dropdownData: [],
        showDownloadModal: false,
        isPaginationClicked: false,
        showUploadModal: false,
        bulkUploadTitle: '',
        filtersApplied: false,
    };
    // set once a search has been requested, so mounting doesn't trigger a second one
    private searchRequested = false;
    constructor(props: any) {
        super(props);
        this.props.fetchExportJobDropdown();
    }

    public componentDidMount() {
        let filters = this.props.location.search.includes('targetQuery=jobCostingFiltersExportJob') ? true : false;
        if (!filters && this.props.filters && this.props.filters.hasOwnProperty('jobCostingFiltersExportJob') && this.props.filters.jobCostingFiltersExportJob) {
            filters = true;
        }
        this.props.displayFilters(filters, 'jobCostingFiltersExportJob');
        this.setState({
            isFetchinProgress: false,
            withoutFilters: filters,
            dropdownData: this.props.documentDropdownData,
        });
        // Filters (a child, so mounted first) may already have started the search; don't repeat it
        if (!this.searchRequested && this.props.exportJobs && this.props.exportJobs.result && this.props.exportJobs.result.length > 0) {
            this.fetchReset();
        }
    }

    public componentDidUpdate(props: IProps, state: any) {
        if (this.props.currentFilters.documentType !== this.state.selectedPrimaryDocument) {
            this.props.setFilter('documentStatus', '');
            this.getDropdownData();
        }

        if (this.props.currentFilters.originDestination !== props.currentFilters.originDestination) {
            const selectedOrigin = this.props.currentFilters.originDestination.split('/')[0];
            const selectedDestination = this.props.currentFilters.originDestination.split('/')[1] === '-' ? '-' : this.props.currentFilters.originDestination.split('/')[1];
            this.props.setFilter('origin', selectedOrigin);
            this.props.setFilter('destination', selectedDestination);
        }

        if (this.props.documentDropdownData !== props.documentDropdownData) {
            if (this.props.currentFilters.documentType === '') {
                this.props.setFilter('documentType', 'FCR');
            }
            this.getDropdownData();
            this.setState({
                dropdownData: this.props.documentDropdownData
            });
        }

        if (this.props.isFetchSearchDataError !== props.isFetchSearchDataError) {
            this.setState({
                showDialog: this.props.isFetchSearchDataError,
                isFetchinProgress: false,
                errorMsg: this.props.searchPendingError.toString() ? this.props.searchPendingError.toString() : 'Request Error'
            });
            if (this.props.location.search) {
                this.props.history.push(this.props.location.pathname);
            }
        }

        if (this.props.exportJobs !== props.exportJobs) {
            if (this.props.exportJobs && this.props.exportJobs.result) {
                this.setData(this.props.exportJobs.result, this.props.exportJobs.page, this.props.exportJobs.pageSize, this.props.exportJobs.totalCount);
                this.setState({
                    totalCount: this.props.exportJobs.totalCount
                });
            }

            if (this.props.location.search) {
                this.props.history.push(this.props.location.pathname);
            }
        }

        if (this.props.searchPendingError !== props.searchPendingError &&
            this.props.isFetchSearchDataError === true) {
            const error = isEmptyError(this.props.searchPendingError, 'Server error');
            this.setState({
                pendingError: error,
                isFetchinProgress: false,
                hasData: false
            });
            if (this.props.location.search) {
                this.props.history.push(this.props.location.pathname);
            }
        }
    }

    public componentWillUnmount() {
        this.props.resetSort();
    }

    public onClickBulkUpload = () => {
        this.setState({
            showUploadModal: true,
            bulkUploadTitle: 'Upload charges from file'
        });
    };

    public handlePageSizeChange = (pageSize: number) => {
        localStorage.setItem('pageSize-ListTable jobCosting-search-exportJob', pageSize.toString());
        this.setState({
            page: 1,
            pageSize,
        });
        this.targetFetch(1, pageSize);
    };

    public handleNextPage = () => {
        if (this.state.totalCount && this.state.pageSize) {
            const pages = Math.ceil(this.state.totalCount / this.state.pageSize);
            if (this.state.page && this.state.page === pages) {
                return;
            } else {
                this.setState((prevState) => ({
                    page: prevState.page ? prevState.page + 1 : 2,
                }), () => {
                    this.targetFetch(this.state.page);
                });
            }
        }
    };

    public handlePreviousPage = () => {
        if (this.state.page && this.state.page > 1) {
            this.setState((prevState) => ({
                page: prevState.page && prevState.page - 1,
            }), () => {
                this.targetFetch(this.state.page);
            });
        } else {
            return;
        }
    };

    public handlePageChange = (page: number) => {
        this.setState({
            page,
        }, () => {
            this.targetFetch(page);
        });
    };

    public handleSorting = (data: any) => {
        this.props.setSort({
            column: data.id,
            order: data.desc ? SORT_ORDER.DESCENDING : SORT_ORDER.ASCENDING,
            desc: data.desc
        });
        this.targetFetch(this.state.page, this.state.pageSize);
    };

    public render() {
        const isBulkFeatureEnabled = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_BULK_UPLOAD_CHARGES_EXPORT, this.props.featureToggles);
        const isBulkFeatureDownloadEnabled = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_BULK_DOWNLOAD_CHARGES_EXPORTJOB, this.props.featureToggles);
        const isBulkSelectForDownloadEnabled = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_BULK_SELECT_FOR_DOWNLOAD, this.props.featureToggles);
        const permissions = this.props.userPermissions.permissions?.find((permission: any) => permission?.businessCapabilityName === uamType.JOBCOSTING || permission?.businessCapabilityName === uamType.ADMIN);
        const isBKSFeatureEnabled = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_BKS_EXTRA_DOC, this.props.featureToggles);
        const isHblConsumptionEnabled = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_HBL_CONSUMPTION, this.props.featureToggles);
        const columns = ExportJObCols(isBKSFeatureEnabled);
        const filtersToAdd = [
            <FiltersSelect
                key="documentType"
                name="documentType"
                id="documentType"
                label="Document"
                isRequired={true}
                options={[
                    ...this.state.primaryDocument
                ]}
            />,
            <FiltersInput
                key="documentNumbers"
                name="documentNumbers"
                label="Document Number"
                id="documentNumbers"
                placeholder={`${this.props.currentFilters.documentType ? this.props.currentFilters.documentType === 'Export Job' ? 'FIN'
                : (this.props.currentFilters.documentType === 'FCR' && isHblConsumptionEnabled ? 'FCR/HBL' : this.props.currentFilters.documentType) : 'FIN'} No`}
            />,
            <FiltersInput
                key="sapSalesOrderNumber"
                name="sapSalesOrderNumber"
                label="SAP SO Number"
                id={'sapSalesOrderNumber'}
            />,
            <FiltersSelect
                key="originDestination"
                name="originDestination"
                id="originDestination"
                label="Origin / Destination Service"
                isRequired={false}
                options={originDestDropdown}
            />,
            <FiltersSelect
                key="errorMessage"
                name="errorMessage"
                id="errorMessage"
                label="Error Message"
                isRequired={false}
                options={messageDropdown}
            />,
            <FiltersInput
                key="consigneeBusinessEntityCode"
                name="consigneeBusinessEntityCode"
                id="consigneeBusinessEntityCode"
                label="Consignee (BE Code)"
            />,
            <FiltersInput
                key="shipperBusinessEntityCode"
                name="shipperBusinessEntityCode"
                id="shipperBusinessEntityCode"
                label="Shipper (BE Code)"
            />,
            <FiltersInput
                key="contractualPartyBusinessEntityCode"
                name="contractualPartyBusinessEntityCode"
                id="contractualPartyBusinessEntityCode"
                label="Contractual Party (BE Code)"
            />,
            <FiltersInput
                key="salesOrg"
                name="salesOrg"
                id="salesOrg"
                label="Sales Organization"
            />,
            <FiltersSelect
                key="source"
                name="source"
                id="source"
                label="Pricing Source"
                isRequired={false}
                options={pricingSourceOptions}
            />,
            <FiltersDateInput
                key="jobCreationDateFrom"
                name="jobCreationDateFrom"
                id="jobCreationDateFrom"
                label="Job Creation Date (From)"
                relatedField="jobCreationDateTo"
                type="dateFromTo"
                setValidity={(val: any) => this.setState({ jobCreationDateFrom: val })}
                isInvalid={this.state.jobCreationDateFrom}
                value=""
                withTime={false}
            />,
            <FiltersDateInput
                key="jobCreationDateTo"
                name="jobCreationDateTo"
                id="jobCreationDateTo"
                label="Job Creation Date (To)"
                minValue="jobCreationDateFrom"
                setValidity={(val: any) => this.setState({ jobCreationDateFrom: val })}
                isInvalid={this.state.jobCreationDateFrom}
                type="dateFromTo"
                withTime={false}
            />,
            <FiltersDateInput
                key="estimatedTimeOfDepartureFrom"
                name="estimatedTimeOfDepartureFrom"
                id="estimatedTimeOfDepartureFrom"
                label="ETD (From)"
                relatedField="estimatedTimeOfDepartureTo"
                type="dateFromTo"
                setValidity={(val: any) => this.setState({ etdFrom: val })}
                isInvalid={this.state.etdFrom}
                value=""
                withTime={false}
            />,
            <FiltersDateInput
                key="estimatedTimeOfDepartureTo"
                name="estimatedTimeOfDepartureTo"
                id="estimatedTimeOfDepartureTo"
                label="ETD (To)"
                minValue="estimatedTimeOfDepartureFrom"
                setValidity={(val: any) => this.setState({ etdFrom: val })}
                isInvalid={this.state.etdFrom}
                type="dateFromTo"
                withTime={false}
            />,
            <FiltersDateInput
                key="estimatedTimeOfArrivalFrom"
                name="estimatedTimeOfArrivalFrom"
                id="estimatedTimeOfArrivalFrom"
                label="ETA (From)"
                relatedField="estimatedTimeOfArrivalTo"
                setValidity={(val: any) => this.setState({ etaFrom: val })}
                isInvalid={this.state.etaFrom}
                type="dateFromTo"
                withTime={false}
            />,
            <FiltersDateInput
                key="estimatedTimeOfArrivalTo"
                name="estimatedTimeOfArrivalTo"
                id="estimatedTimeOfArrivalTo"
                label="ETA (To)"
                minValue="estimatedTimeOfArrivalFrom"
                setValidity={(val: any) => this.setState({ etaFrom: val })}
                isInvalid={this.state.etaFrom}
                type="dateFromTo"
                withTime={false}
            />,
            <FiltersInput
                key="placeOfReceipt"
                name="PlaceofReceipt"
                id="PlaceofReceipt"
                label="Place of Receipt"
            />,
            <FiltersInput
                key="portofLoading"
                name="PortofLoading"
                id="PortofLoading"
                label="Port of Loading"
            />,
            <FiltersInput
                key="portOfDischarge"
                name="PortOfDischarge"
                id="PortOfDischarge"
                label="Port Of Discharge"
            />,
            <FiltersInput
                key="placeOfDelivery"
                name="PlaceOfDelivery"
                id="PlaceofDelivery"
                label="Place of Delivery"
            />,


        ];

        if (isBKSFeatureEnabled) {
            filtersToAdd.splice(4, 0, <FiltersSelect
                key="productType"
                name="productType"
                id="productType"
                label="Product Type"
                options={[
                    ...searchProductTypes
                ]}
            />);
        }

        if (this.state.selectedPrimaryDocument !== 'CBL'){
            filtersToAdd.push(
                <FiltersSelect
                    key="cblStatus"
                    name="cblStatus"
                    id="cblStatus"
                    label="CBL Status"
                    options={[
                        ...searchCBLStatuses
                    ]}
                />
            )
        }

        if (this.state.selectedPrimaryDocument !== 'FRN') {
            filtersToAdd.splice(2, 0, <FiltersSelect
                key="documentStatus"
                name="documentStatus"
                id="documentStatus"
                label="Document Status"
                isRequired={false}
                options={[
                    ...this.state.primaryDocumentStatus
                ]}
            />);
        }

        return (
            <Search triggerFetch={() => this.targetFetch()} withoutFilters={this.state.withoutFilters}>
                <InPageDialog
                    showDialog={this.state.showDialog}
                    type={'error'}
                    message={this.state.errorMsg}
                    closeMethod={() => this.setState({ showDialog: false, errorMsg: '' })} />
                <Filters
                    tableNameKey="jobCostingFiltersExportJob"
                    defaultFilters={() => ({
                        ...lastThreeMonthsFilters('jobCreationDateFrom', 'jobCreationDateTo')(),
                        documentType: 'FCR'
                    })}
                    genericFilter={this.state.genericFilter}
                    fetchFunction={() => this.fetchReset()}
                    withoutFilters={this.state.withoutFilters}
                    filters={filtersToAdd}
                    resetErrors={() => this.resetDates()}
                    disableSubmit={this.state.etaFrom || this.state.etdFrom || this.state.jobCreationDateFrom}
                    resetPaging={(pageNumber: any, pageSize: any) => {
                        this.setState({
                            page: 1,
                            totalCount: 0,
                            exportJobs: [],
                            clearFilters: false,
                            hasData: false
                        });
                    }}
                />
                <TabComponent
                    name="search-results"
                    activeTab={0}
                    navLinks={[{
                        id: 1,
                        title: 'Export Job',
                        emptyLabel: ''
                    }]}
                    callbackFc={(e: number) => this.setState({ activeTab: e })}
                />

                {this.state.showUploadModal &&
                    <div className="uploadModal">
                        <ModalMain height={450}
                            modal={this.state.showUploadModal}
                            title={this.state.bulkUploadTitle}
                            hideMethod={() => this.setState({ showUploadModal: false })}
                            secondaryMethod={() => this.setState({ showUploadModal: false })}
                            primaryMethod={() => this.setState({ showUploadModal: false })} btnTitle1={'OK'} btnTitle2={'Close'}>
                            <UploadSection
                                name={'upload-control-export'}
                                refreshName={'upload-control-export-refresh'}
                                fileFormats={'.xlsx'}
                                restrictionText={'Optional upload text'}
                                entityType={'FinOpsExport'}
                                catagory={'export'}
                            />

                        </ModalMain>
                    </div>
                }

                {this.state.showDownloadModal &&
                    <div className="uploadModal">
                        <ModalMain height={330}
                            modal={this.state.showDownloadModal}
                            title={'Download charges to file'}
                            hideMethod={() => this.setState({ showDownloadModal: false })}
                            secondaryMethod={() => this.setState({ showDownloadModal: false })}
                            primaryMethod={() => this.setState({ showDownloadModal: false })} btnTitle1={'OK'} btnTitle2={'Close'}>
                            <div>
                                <BulkDownload catagory={'export'} />
                            </div>
                        </ModalMain>
                    </div>
                }

                <CustomTable
                    tableId="jobCosting-search-exportJob"
                    isBulkFeatureEnabled={isBulkFeatureEnabled}
                    isFeatureEnabled={isBulkFeatureDownloadEnabled}
                    hasUAMPermission={permissions?.permission !== '' ? true : false}
                    columns={columns}
                    rows={this.state.exportJobs}
                    selectedPage={this.state.page}
                    pageSize={this.state.pageSize}
                    pageCount={Math.ceil(this.state.totalCount / this.state.pageSize)}
                    clearFilters={this.state.clearFilters}
                    filtersApplied={this.state.filtersApplied}
                    onImportChargesClick={this.onClickBulkUpload}
                    sortingAction={this.handleSorting}
                    linkAction={(e: any) => {
                        const url = `/job-costing/exportjobs/${e.exportJobId}`;
                        this.linkAction(url);
                    }}
                    nextPageAction={this.handleNextPage}
                    previousPageAction={this.handlePreviousPage}
                    pageChangeAction={this.handlePageChange}
                    pageSizeChanged={this.handlePageSizeChange}
                    downloadToFileAction={(data: any) => { this.bullkDownloadActionExport(data); }}
                    totalCount={this.state.totalCount}
                    fetchRowsForBulkDownload={isBulkSelectForDownloadEnabled ? this.props.fetchExportJobsPageForDownload : undefined}
                />
            </Search>
        );
    }

    private bullkDownloadActionExport = async (data: any) => {
        const ids = data.map((item: any) => item.exportJobId);
        if (data.length > 0) {
            await this.props.bulkDownloadExportJobs(ids);
            this.setState({
                showDownloadModal: true,
            });
        }
    };

    private getDropdownData = () => {
        const isHblConsumptionEnabled = isFeatureEnabled(FEATURE_TOGGLES.FINOPS_HBL_CONSUMPTION, this.props.featureToggles);
        const dataDropdown = this.props.documentDropdownData && groupBydocumentType(this.props.documentDropdownData);
        const primaryData = dataDropdown.map((item: any) => {
            return {
                // display-only label; value stays 'FCR' so the backend request is unaffected
                optionText: item.documentType === 'FCR' && isHblConsumptionEnabled ? 'FCR/HBL' : item.documentType,
                value: item.documentType,
            };
        });
        this.setState({
            selectedPrimaryDocument: this.props.currentFilters.documentType,
            primaryDocument: primaryData,
        });
        const primaryDataStatus = dataDropdown
            .filter((item: any) => item.documentType === this.props.currentFilters.documentType)
            .map((item: any) => item.documentStatusName).flat()
            .map((item: any) => {
                return {
                    optionText: item,
                    value: item,
                };
            });
        this.setState({
            primaryDocumentStatus: primaryDataStatus,
            selectedPrimaryDocumentStatus: this.props.currentFilters.documentStatus
        });
    };

    private setData = (data: any, page: number | undefined, pageSize: number, totalCount: number) => {
        localStorage.setItem('pageSize-ListTable', pageSize.toString());
        if (isFeatureEnabled(FEATURE_TOGGLES.EXTRA_DOCUMENT, this.props.featureToggles)) {
            if (data && data.length) {
                data = data.map((item: any) => {
                    if (item.primaryDocumentNumber && item.exportJobNumber && item.exportJobNumber.indexOf('/') === -1) {
                        item.exportJobNumber = `${item.exportJobNumber}/${item.primaryDocumentNumber}`;
                    }
                    if (item.destination && item.origin && item.origin.indexOf('/') === -1) {
                        item.origin = `${item.origin}/${item.destination}`;
                    }
                    if (item.rateErrorMessage && item.agedInHrs >= 0) {
                        item.agedTime = getAgingBucket(item.agedInHrs);
                    }
                    if (item.exportJobId) {
                        item.id = item.exportJobNumber;
                    }
                    return item;
                });
            }
        }
        this.setState({
            page,
            pageSize,
            totalCount,
            isFetchinProgress: false,
            hasData: true,
            exportJobs: data
        });
    };

    private linkAction = (url: string) => {
        return this.props.history.push(url);
    };

    private resetDates = () => {
        if (this.props.exportJobs && this.props.exportJobs.result?.length > 0) {
            this.props.resetExportJobs();
        }
        this.setState({
            sorted: [],
            page: 1,
            totalCount: 0,
            etaFrom: false,
            etdFrom: false,
            jobCreationDateFrom: false,
            isFetchinProgress: true,
            exportJobs: [],
            clearFilters: true,
            shouldClear: true,
            hasData: false,
            selectedPrimaryDocument: '',
            selectedPrimaryDocumentStatus: '',
            primaryDocument: [],
            primaryDocumentStatus: [],
        });
    };

    private targetFetch = (page: number = this.state.page, pageSize: number = this.state.pageSize) => {
        const tempPageSize: any = localStorage.getItem('pageSize-ListTable jobCosting-search-exportJob') ?
            localStorage.getItem('pageSize-ListTable jobCosting-search-exportJob') : pageSize;
        this.setState({
            isFetchinProgress: true,
            pageSize: tempPageSize,
            isPaginationClicked: false
        }, () => {
            this.props.fetchExportJobs(page, tempPageSize, this.state.genericFilter);
        });
    };

    private fetchReset =(page: number = 1, pageSize: number = 10) => {
        if (!this.state.clearFilters) {
            this.searchRequested = true;
            const p = this.state.page ? this.state.page : page;
            const pS = this.state.pageSize ? this.state.pageSize : pageSize;
            this.setState({
                page: p,
                pageSize: pS,
                filtersApplied: true,
            }, () => {
                this.targetFetch(p, pS);
                setTimeout(() => {
                    this.setState({
                        filtersApplied: false
                    });
                }, 100);
            });
        } else {
            this.props.setFilter('documentType', 'FCR');
        }
    };
}
const mapStateToProps = (state: IStore): IMapStateToProps => ({
    isFetchSearchDataLoading: state.exportJob.isFetchDataLoading,
    isFetchSearchDataError: state.exportJob.isFetchDataError,
    searchPendingError: state.exportJob.detailsPendingError,
    exportJobs: state.exportJob.exportJobs,
    filters: state.filters.hideFilters,
    currentFilters: state.filters.filters,
    featureToggles: state.featureToggle.featureToggles,
    documentDropdownData: state.exportJob.documentDropdownData,
    userPermissions: state.user.userPermissions,
});

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, Action>): IMapDispatchToProps => ({
    fetchExportJobs: (pageNumber: number, pageSize: number, genericFilter: string) => dispatch(fetchExportJobs(pageNumber, pageSize, genericFilter)),
    setSort: (sort: ISortModel) => dispatch(setSort(sort)),
    resetSort: () => dispatch(resetSort()),
    displayFilters: (hideFilters: boolean, target: string) => dispatch(displayFilters(hideFilters, target)),
    resetExportJobs: () => dispatch(resetExportJobs()),
    fetchExportJobDropdown: () => dispatch(fetchExportJobDropdown()),
    setFilter: (name: string, value: string | boolean | any[] | number) => dispatch(setFilter(name, value)),
    bulkDownloadExportJobs: (ids: []) => dispatch(bulkDownloadExportJobs(ids)),
    fetchExportJobsPageForDownload: (pageNumber: number, pageSize: number) => dispatch(fetchExportJobsPageForDownload(pageNumber, pageSize)),
});
const __SearchD = connect<IMapStateToProps, IMapDispatchToProps, {}, IStore>(mapStateToProps, mapDispatchToProps)(_SearchExportJobs);
export const SearchExportJobs = withRouter(__SearchD);